<template>
    <main-section class="main-section--sm pt-0">
        <square-title>협력 파트너사</square-title>

        <v-row justify="center">
            <v-col v-for="(partner, index) in partners" :key="index" cols="6" md="4" lg="3">
                <v-card outlined class="partner-card rounded-xl">
                    <div class="w-100">
                        <v-img width="100%" max-width="154" :src="partner.logo" alt="" class="mx-auto mb-16px" />
                        <div class="font-size-12 font-size-md-20 grey--text text--darken-4 text-pre-wrap">{{ partner.name }}</div>
                    </div>
                </v-card>
            </v-col>
        </v-row>

        <p class="tit tit--xs text-center pt-6 pt-md-10">협력 연구 등을 위해 지역의 대학, 연구소, 진흥원, 센터 등과 활발한 교류로 <span class="primary--text">기술력 축적</span> 및 <span class="primary--text">신제품 출시</span></p>
    </main-section>
</template>

<script>
import MainSection from "@/components/client/inc/main-section.vue";
import SquareTitle from "../dumb/square-title.vue";

export default {
    components: {
        MainSection,
        SquareTitle,
    },
    data() {
        return {
            partners: [
                {
                    name: "강원대학교",
                    logo: "/images/main/partners/partner-knu.png",
                },
                {
                    name: "한림대학교",
                    logo: "/images/main/partners/partner-hlu.png",
                },
                {
                    name: "가톨릭 관동대학교",
                    logo: "/images/main/partners/partner-cku.png",
                },
                {
                    name: "(재)춘천바이오\n산업진흥원",
                    logo: "/images/main/partners/partner-c3f.png",
                },
                {
                    name: "강릉과학산업진흥원",
                    logo: "/images/main/partners/partner-gsipa.png",
                },
                {
                    name: "(재)홍천메디컬\n허브연구소 ",
                    logo: "/images/main/partners/partner-himh.png",
                },
                {
                    name: "한국과학기술연구원\n강릉분원",
                    logo: "/images/main/partners/partner-kist.png",
                },
                {
                    name: "(재)농축산용 미생물\n산업육성지원센터",
                    logo: "/images/main/partners/partner-cialm.png",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.partner-card {
    border-color: var(--v-primary-lighten3) !important;
    padding: 20px 12px;
    text-align: center;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
@media (min-width: 768px) {
    .partner-card {
        min-height: 180px;
    }
}
</style>